export default __webpack_public_path__ + "static/media/principal.8e2905f6.jpg";